module.exports = __webpack_public_path__ + "static/img/landing-screen-1.e0289e6.jpg";